import {defaultCountry, countryTextMap} from '@stencil/hotels-config/src/config/app-config';
import {resetSelectedProperty} from '@stencil/hotels-common-reducer/src/actions';

export default function autosuggestOnSelectionhandler(
  changes,
  updateQueryCaller,
  updatePropertyDetails,
  dispatch,
) {
  let country = defaultCountry;
  if (changes && changes.selectedItem && changes.selectedItem.xtr?.cc) {
    country = changes.selectedItem.xtr?.cc || '';
    if (changes.selectedItem.xtr.flt) {
      // ! if there is an explicit product ask
      // ! otherwise, filter stuff coming from voyager will anyway get consumed at UpdateSearch level
      // const voyagerTransformedFilter = voyagerResultToFilter(
      //   changes.selectedItem,
      //   filterInState,
      // );
      // updateFilterCaller({...voyagerTransformedFilter});
    }
  }

  let mmtId = '';

  if (changes.selectedItem?.t === 'hotel') {
    mmtId = changes.selectedItem?.mmtId || '';
    updatePropertyDetails({
      propertyId: changes.selectedItem?._id,
      propertyName: changes.selectedItem?.n,
      mmtId: changes.selectedItem?.mmtId || '',
    });
  } else {
    mmtId = '';
    dispatch(resetSelectedProperty());
    updatePropertyDetails({
      // resetFlag: true
      propertyId: '',
      propertyName: '',
      mmtId: '',
    });
  }
  updateQueryCaller({
    destination: {...changes.selectedItem, auto: 'true'},
    locus: changes?.selectedItem?.locus,
    country: country,
    sType: changes.selectedItem?.t,
    topHtlId: mmtId,
    mmtId: mmtId,
  });
}
